import { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Mixpanel from "mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";
import { getProjectList } from "../../features/projectManagement/getProjectListSlice";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { labelListing } from "../../features/user-document/label-listing";
import Button from "../form-components/Button";
import AddProjectModal from "../setting-component/modal/AddProjectModal";

const SwitchProjectModal = ({
  isOpen,
  toggle,
  title,
  currentModal,
  setCurrentModal,
  isChatPage = false,
}) => {
  const { projectListing = null } = useSelector((state) => ({
    projectListing: state?.getProjectListReducer?.responseData?.projects,
  }));

  let [selectedProject, setSelectedProject] = useState("");
  let projectData = JSON.parse(localStorage.getItem("_user"));
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProjectList({ perPage: 100, page: 1 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* useEffect(() => {
        if (selectedProject) {
            projectData.projects[0].uuid = selectedProject;
            projectData.projects[0].name = selectedProjectName;
            localStorage.setItem('_user', JSON.stringify(projectData));
        }
    }, []); */
  const handleCloseSwitchModal = async () => {
    Mixpanel.track("Switch project modal", {
      Page: "Switch project modal",
    });
    toggle();
    if (!isChatPage) {
      dispatch(
        getDocuments({
          perPage: 10,
          page: 1,
          project_uuid: projectData?.projects[0]?.uuid,
        })
      );
      await dispatch(labelListing(projectData?.projects[0]?.uuid));
    } else {
      localStorage.setItem("_user", JSON.stringify(projectData));
      window.location.href = `${
        JSON.parse(localStorage.getItem("_user"))["projects"][0]["slug"]
      }`;
    }
  };

  return (
    <>
      <Modal
        className="add-document-popup"
        show={isOpen}
        onHide={toggle}
        // modalTransition={{ timeout: 2000 }}
        dialogClassName="common-modal modal-dialog-centered"
        backdrop={"static"}
        keyboard={false}
      >
        <Modal.Header>
          <h3 className="modal-title" id="Switch_OrganizationLabel">
            {title}
          </h3>
          <Button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleCloseSwitchModal}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <ul className="switch-list">
            {projectListing?.length > 0 &&
              projectListing.map((data, index) => {
                return (
                  <li key={index}>
                    <div className="form-check" key={`${index}15`}>
                      <input
                        className="form-check-input"
                        type="radio"
                        onChange={(e) => {
                          /* setSelectedProject(e.target.value);
                                                    setSelectedProjectName(projectData.projects[0].uuid === data?.uuid && data?.name); */
                          projectData.projects[0].uuid = e.target.value;
                          projectData.projects[0].name =
                            projectData.projects[0].uuid === data?.uuid &&
                            data?.name;
                            projectData.projects[0].slug =
                              projectData.projects[0].uuid === data?.uuid &&
                              data?.slug;
                            projectData.projects[0].website_logo =
                              projectData.projects[0].uuid === data?.uuid &&
                              data?.website_logo;
                            if (!isChatPage) {
                            localStorage.setItem(
                              "_user",
                              JSON.stringify(projectData)
                            );
                          }
                        }}
                        defaultChecked={
                          data?.uuid === selectedProject
                            ? true
                            : projectData.projects[0].uuid === data?.uuid
                        }
                        name="list_radio"
                        id={index}
                        value={
                          projectData.projects[0].uuid === data?.uuid
                            ? true
                            : data?.uuid
                        }
                        key={`${index}13`}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor={index}
                        key={`${index}12`}
                      >
                        {data?.name}
                      </label>
                    </div>
                  </li>
                );
              })}
          </ul>
          <Button
            className="add-link btn"
            onClick={() => setCurrentModal("addProjectModal")}
          >
            Add New Project
          </Button>
        </Modal.Body>
      </Modal>
      {currentModal === "addProjectModal" && (
        <AddProjectModal
          isVisible={currentModal === "addProjectModal"}
          toggleFunction={() => setCurrentModal("")}
        />
      )}
    </>
  );
};

export default SwitchProjectModal;
